const ReviewerProfile = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/reviewerDetail/ReviewerProfile.vue"
  );
const ReviewerDomains = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/reviewerDetail/ReviewerDomains.vue"
  );

export default [
  {
    path: ":userId/profile",
    name: "admin-reviewers-profile",
    component: ReviewerProfile,
  },
  {
    path: ":userId/domains",
    name: "admin-reviewers-domains",
    component: ReviewerDomains,
  },
];
